import _ from 'lodash'
import useAsyncWithCache from 'modules/asyncCache/useAsyncWithCache'
import React, {useContext} from 'react'
import {LocalContext} from '../../../../modules/local/LocalContext'
import {TagCloudChart} from '../../../Chart/Charts/ChartComponents/TagCloudChart'
import {godwords_getStatsByTagCloud_Api} from "../../../../apis/godwords";
import {NullAsDefault} from "../../../Shared";
import Pure from "../../../../components/Pure";

export const TagCloudWoGHashTags = ({setHashtags = NullAsDefault, minHeight = 280}) => {
  const apiInfo = godwords_getStatsByTagCloud_Api
  const {lang} = useContext(LocalContext)

  const id = ['god_word_hashtags', 'cloud', 'tag', lang].join('_')

  const cacheId = [apiInfo?.path, id].join('/')

  const {response} = useAsyncWithCache({
    cacheId,
    apiInfo,
  })

  const data = _.get(response, 'data.data', [])

  if (_.isEmpty(data)) {
    return null
  }

  return (
    <Pure>
      <div style={{maxWidth: '100%', minHeight}} className="mt-3 md:mt-0">
        <TagCloudChart
          minHeight={minHeight}
          chartInfo={{
            id,
            idname: id,
            data_values: data,
          }}
          params={{search_param: "wog_hashtags"}}
        />
      </div>
    </Pure>
  )
}
